class ElementTopTasks {
  constructor() {
    this.unifyTaskRowsHeight()
    window.addEventListener("resize", this.unifyTaskRowsHeight)
  }

  unifyTaskRowsHeight() {
    document.querySelectorAll(".element-top-task-row").forEach(row => {
      let maxImageWrapperHeight = 0
      let maxTitleHolderHeight = 0
      row.querySelectorAll(".top-task-widget-img-wrapper").forEach(imageWrapper => {
        // for quicker converge
        let skippingTheRest = false

        Array.from(imageWrapper.children).forEach(child => {
          if (skippingTheRest) {
            return
          }

          if (child.offsetHeight > 0) {
            skippingTheRest = true

            if (maxImageWrapperHeight < child.offsetHeight) {
              maxImageWrapperHeight = child.offsetHeight
            }
          }
        })
      })
      row.querySelectorAll(".top-task-widget-img-wrapper").forEach(imageWrapper => {
        imageWrapper.style.height = maxImageWrapperHeight + "px"
      })
      row.querySelectorAll(".top-task-widget-title-holder").forEach(titleHolder => {
        if (maxTitleHolderHeight < titleHolder.children[0].offsetHeight) {
          maxTitleHolderHeight = titleHolder.children[0].offsetHeight
        }
      })
      row.querySelectorAll(".top-task-widget-title-holder").forEach(titleHolder => {
        titleHolder.style.height = maxTitleHolderHeight + "px"
      })
    })
  }
}

export default ElementTopTasks
